import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { ConfigService } from 'src/app/shared/services/multi-clients/config.service';

@Injectable({ providedIn: 'root' })
export class FeatureGuard  {

  constructor(
    private _router: Router,
    private _configService: ConfigService
  ) { }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!route.data.feature || !this._configService.settings.features[route.data.feature]) {
      this._router.navigate(['']);
      return false;
    } else {
      return true;
    }
  }

}
